import styled from 'styled-components';
import { Linha } from '../../styles/base';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const PerguntaRespostaSic = styled(Linha)`
  background-color: #f2f2f2;
  padding: ${espacamento.ultraPequeno}px;
  border-radius: ${bordaArredondar}px;
  overflow-wrap: anywhere;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
`;
